import { HttpStatusCode } from 'axios';

import { ErrorMessage } from '@/core/constants/ErrorMessage';
import MessageHelper from '@/core/helpers/MessageHelper';
import NumberHelper from '@/core/helpers/NumberHelper';
import StringHelper from '@/core/helpers/StringHelper';

import PriceRepositoryInterface from '../interface-adapters/PriceRepositoryInterface';
import StringResult from '@/core/models/StringResult';

export default class PriceRepository implements PriceRepositoryInterface {
    format(price: number, currency: string, defaultText?: string): StringResult {
        let result = new StringResult();
        if (NumberHelper.isValid(price) === false) {
            result.message = MessageHelper.format(ErrorMessage.INVALID_PARAMETER, 'price');
            result.responseCode = HttpStatusCode.BadRequest;
            return result;
        }

        if (StringHelper.isHasValue(currency) === false) {
            result.message = MessageHelper.format(ErrorMessage.NULL_OR_EMPTY_PARAMETER, 'currency');
            result.responseCode = HttpStatusCode.BadRequest;
            return result;
        }

        result.success = true;
        if (NumberHelper.isPositive(price)) {
            result.data = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
        } else {
            result.data = defaultText ?? '';
        }

        return result;
    }
}
